// extracted by mini-css-extract-plugin
export default {"messageContainer":"tw97eQ2La7okaM3dhF6U","imgContainer":"LEMBkyiJGhYoaieFUhOS","divider":"wInm8EnDvn1lLan4_dJO"};